'use client';
import MuiIMenuItem from '@mui/material/MenuItem';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import idsTokensDefault from '../../utils/tokens/idsTokens';
import withRef from '../../utils/withRef';

export const styles = ({ idsTokens = idsTokensDefault }) => ({
  root: {
    '&:not(.IDS-columnSettingsMenuItem):active': {
      color: idsTokens.listItem.default.color.text.label.pressed,
      backgroundColor: idsTokens.listItem.default.color.background.pressed,
    },
  },
  rootError: {
    '&:not(.IDS-columnSettingsMenuItem):active': {
      color: idsTokens.listItem.error.color.text.label.pressed,
      backgroundColor: idsTokens.listItem.error.color.background.pressed,
    },
  },
  withActions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  actionsWrapper: {
    display: 'flex',
    gap: 2,
    marginRight: -20,
  },
  focusVisible: {
    outline: 'none',
    '&:not(.IDS-columnSettingsMenuItem)': {
      color: idsTokens.listItem.default.color.text.label.focus,
      backgroundColor: idsTokens.listItem.default.color.background.focus,
      border: '2px solid rgba(0,0,0,0)',
    },
  },
  focusVisibleError: {
    outline: 'none',
    '&:not(.IDS-columnSettingsMenuItem)': {
      color: idsTokens.listItem.error.color.text.label.focus,
      backgroundColor: idsTokens.listItem.error.color.background.focus,
      border: '2px solid rgba(0,0,0,0)',
    },
  },
});

const useStyles = makeStyles()(styles);

export const MenuItem = ({ className, destructiveAction, Actions, forwardedRef: ref, ...rest }) => {
  const { classes } = useStyles();

  return (
    <MuiIMenuItem
      classes={{
        focusVisible: destructiveAction ? classes.focusVisibleError : classes.focusVisible,
      }}
      className={clsx(
        /** Mui-error class provides styles coming from src/components/List/classes.js */
        destructiveAction && 'Mui-error',
        destructiveAction ? classes.rootError : classes.root,
        className,
        Actions && classes.withActions
      )}
      {...rest}
      ref={ref}
    >
      {rest.children}
      {Actions && (
        <div className={classes.actionsWrapper} onClick={(e) => e.stopPropagation()}>
          {Actions}
        </div>
      )}
    </MuiIMenuItem>
  );
};

MenuItem.propTypes = {
  /** Node containing IconButtons or Buttons, to indicate optional, additional actions beyond selection. */
  Actions: PropTypes.node,
  /** If `true`, destructive action style will be applied. */
  destructiveAction: PropTypes.bool,
};

export default withRef()(MenuItem);
